<mojo-reports-job-list-common
  [jobTitle]="'Job details'"
  [leftColumnTitle]="'Avg. response time'"
  [rightColumnTitle]="'Direct applicants'"
  [allJobs]="allJobs"
>
  <mojo-dashboard-job-item
    job-item
    *ngFor="let job of allJobs?.content"
    [jobItem]="job"
    [avgResponseTime]="getAvgResponseTimes(job.id) | async"
    [aggregatedJobData]="getAggregatedJobData(job.id) | async"
  >
  </mojo-dashboard-job-item>
  <mojo-pagination
    pagination
    [pagination]="allJobs"
    (pageChange)="pageChange($event)"
  >
  </mojo-pagination>
</mojo-reports-job-list-common>
